var BASE_URL = process.env.REACT_APP_BASE_URL;
var API_URL = process.env.REACT_APP_API_URL;
var ASSET_URL = process.env.REACT_APP_ASSET_URL;
var S3_URL = process.env.REACT_APP_S3_BASE_URL;
export const config = {
  baseUrl: BASE_URL,
  apiUrl: API_URL,
  encsecretKey: "q3432464dbcfxbdfg",
  asset_url: ASSET_URL,
  s3Url: S3_URL,
  maxFileSize: 8000000,
};
